import React from "react";
import { getImageUrl } from "../../../commons/assets_path";
import { useTranslation } from "react-i18next";

export const RequiredText = () => {
  const { t } = useTranslation();
  return (
    <span className="required_field">
      <img src={getImageUrl(`images/icons/asterisk.svg`)} alt={t("RequiredText.必須")} width="16" height="16" />
      {t("RequiredText.必須")}
    </span>
  );
};
